/**
 * AboveHeader component
 *
 * Renders the global promo banner above the main header.
 * Fetches PromoBanner content from Contentful and displays it.
 */

import React from 'react';

import {usePromoBanners} from '@amblique/king-living/app/contentful/hooks';
import {PromoBanner} from '@amblique/king-living/app/contentful/models/promo-banner';

/**
 * AboveHeader component - Renders PromoBanner above the main header
 *
 * @returns {React.ReactElement|null}
 */
const AboveHeader = () => {
  // Fetch the first PromoBanner from Contentful with full variant to include links
  const {
    data: promoBannerCollection,
    isLoading,
    error,
  } = usePromoBanners({
    variant: 'full', // Use 'full' variant to include nested link data
    variables: {
      limit: 1,
    },
  });

  // Get the first promo banner
  const promoBanner = promoBannerCollection?.items?.[0];

  // Don't render anything while loading or if there's an error
  if (isLoading || error || !promoBanner) {
    return null;
  }

  return (
    <PromoBanner
      component={promoBanner}
      isComplete={true}
      isFetching={false}
    />
  );
};

export default AboveHeader;
